export const staff_tracking = {
  title: `Suivi du personnel`,

  staff: `Utilisateur`
};
